/**
 * Google Tag Manager helper functions
 */

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

/** Send event to GTM dataLayer */
export function pushToDataLayer(eventData: Record<string, unknown>) {
  try {
    if (typeof window !== "undefined" && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(eventData);
    }
  } catch (error) {
    console.debug("GTM event skipped:", error);
  }
}

/** Standard GTM event with common properties */
export function gtmEvent(event: string, properties?: Record<string, unknown>) {
  pushToDataLayer({ event, ...properties });
}
